<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveBankCommodity"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal>
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">&times;</button>
          <h2 class="modal-title">Bank Commotity - {{BankCommodityId==null?"Add":"Edit"}}</h2>
        </div>
        <div slot="body">
          <div v-if="BankCommodityError_message != '' && BankCommodityError_message!=null">
            <div class="alert alert-danger text-center">
              <strong>{{BankCommodityError_message}}</strong>
            </div>
          </div>
          <div v-if="success_message!=null && success_message!=''">
            <div class="alert alert-success text-center">
              <strong>{{success_message}}</strong>
            </div>
          </div>
          <div v-if="errorMessage !=null && errorMessage!=''">
            <div class="alert alert-danger text-center">
              <strong>{{errorMessage}}</strong>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-6">
              <label>
                Commodity
                <span class="text-danger">*</span>
              </label>
            </div>
            <div class="col-xs-6">
              <select
                class="form-control"
                name="CommodityId"
                v-model="CommodityId"
                @change="GetBuyerSeller"
              >
                <option
                  v-for="(option,index) in GetCommodity"
                  :value="option.Id"
                  :key="'C'+index"
                >{{option.Name}}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-6">
              <label>
                Supplier
                <span class="text-danger">*</span>
              </label>
            </div>
            <div class="col-xs-6">
              <select class="form-control" name="SupplierId" v-model="SupplierId">
                <option
                  v-for="(option,index) in Getsupplier"
                  :value="option.Id"
                  :key="'S'+index"
                >{{option.Name}}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-6">
              <label>
                Purchaser
                <span class="text-danger">*</span>
              </label>
            </div>
            <div class="col-xs-6">
              <select class="form-control" name="PurchaserId" v-model="PurchaserId">
                <option
                  v-for="(option,index) in GetPurchaser"
                  :value="option.Id"
                  :key="'S'+index"
                >{{option.Name}}</option>
              </select>
            </div>
            <div class="col-xs-6">
              <strong current-date></strong>
            </div>
          </div>
        </div>
        <div slot="footer">
          <span class="pull-left text-danger">*Mandatory fields</span>
          <loading v-if="loading"></loading>
          <input type="submit" class="btn btn-primary" value="Save" />
          <input
            type="button"
            class="btn btn-danger"
            v-if="CommodityId&&CommodityId!=0"
            value="Delete"
            @click="DeleteBankCommodity"
          />
          <button class="btn btn-warning" @click="CloseModal">Cancel</button>
        </div>
      </modal>
    </form>
  </div>
</template>


<script>
import { mapFields } from "vee-validate";
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState, Store } from "vuex";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      BankCommodityError_message: null,
      success_message: null,
      CommodityId: null,
      SupplierId: null,
      PurchaserId: null
    };
  },
  props: { BankCommodityId: Number },
  methods: {
    CloseModal() {
      this.$emit("Close");
    },
    GetBuyerSeller() {
      if (this.CommodityId == 0 || this.CommodityId == null) {
        return;
      }
      var url =
        "?currentpage=1&pagesize=0&Id=" + this.CommodityId + "&search=S";
      this.$store
        .dispatch(ACTIONS.BANKCOMMODITIES_GET_PURCHASER, url)
        .then(res => {})
        .catch(err => {});
    },

    getAllCommodities() {
      var url = "?currentpage=1&pagesize=0&search=&status=false";
      this.CommodityId = null;
      this.PurchaserId = null;
      this.$store
        .dispatch(ACTIONS.BANKCOMMODITIES_GET_COMMODITY, url)
        .then(res => {})
        .catch(err => {
          console.log(err);
        });
    },
    getData() {
      var url = "?id=" + this.BankCommodityId;
      var vm = this;
      this.$store
        .dispatch(ACTIONS.BANKCOMMODITIES_GET, url)
        .then(res => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            var { bankCommodity } = data.ResponseData;
            vm.CommodityId = bankCommodity.CommodityId;
            vm.SupplierId = bankCommodity.SupplierId;
            vm.PurchaserId = bankCommodity.PurchaserId;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    DeleteBankCommodity() {
      var vm = this;

      if (this.CommodityId && this.CommodityId != 0) {
        var params = new URLSearchParams();
        params.append("CommodityId", this.CommodityId);
        this.$store
          .dispatch(ACTIONS.DELETE_BANK_COMMODITY, params)
          .then(res => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              vm.success_message = "Bank Commodity deleted successfully";
              setTimeout(function() {
                vm.success_message = null;
                vm.CloseModal();
              }, 1500);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.BankCommodityError_message = "Please Select Commodity";
        setTimeout(function() {
          vm.BankCommodityError_message = null;
        }, 1800);
      }
    },
    saveBankCommodity() {
      if (
        this.SupplierId == null ||
        this.SupplierId == 0 ||
        (this.PurchaserId == null || this.PurchaserId == 0)
      ) {
        var vm = this;
        if (
          this.SUPPLIER &&
          this.SUPPLIER.length > 0 &&
          (this.PURCHASER && this.PURCHASER.length > 0)
        ) {
          this.BankCommodityError_message =
            "Please select  supllier and purchaser ";
        } else {
          if (this.CommodityId == null || this.CommodityId == 0) {
            this.BankCommodityError_message = "Please select comodity";
          } else {
            this.BankCommodityError_message = "Please Add commodity for vendor";
          }
        }
        setTimeout(function() {
          vm.BankCommodityError_message = null;
        }, 1800);
        return;
      }
      var data = {
        CommodityId: this.CommodityId,
        SupplierId: this.SupplierId,
        PurchaserId: this.PurchaserId
      };

      var vm = this;
      this.$store
        .dispatch(ACTIONS.BANK_COMMODITY_SAVE, data)
        .then(res => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            if (vm.BankCommodityId) {
              vm.success_message = "Bank Commodity modified successfully";
            } else {
              vm.success_message = "Bank Commodity added successfully";
            }
            setTimeout(function() {
              vm.success_message = null;
              vm.CloseModal();
            }, 1500);
          } else {
            console.log(res);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeMount() {
    if (this.BankCommodityId) {
      this.getData();
    } else {
      this.getAllCommodities();
    }
  },
  computed: {
    ...mapGetters({
      errorMessage: "GETBANKCOMMODITYSAVEERRORMESSAGE",
      loading: "GETBANKCOMMODITYSAVELOADING",
      SUPPLIER: "GETBANKCOMMODITYSUPPLIER",
      PURCHASER: "GETBANKCOMMODITYPURCHASER",
      COMMODITIES: "GETBANKCOMMODITYCOMMODITIES",
      BANKCOMMODITY: "GETBANKCOMMODITY"
    }),
    // ...mapFields({
    //   CommodityFlags: "CommodityId",
    //   SupplierFlags: "SupplierId",
    //   PurchaserFlags: "PurchaserId"
    // }),
    GetCommodity() {
      var cm = [{ Name: "Select Commodity", Id: 0 }, ...this.COMMODITIES];
      return cm;
    },
    GetPurchaser() {
      var cm = [{ Name: "Select Commodity", Id: 0 }, ...this.PURCHASER];
      return cm;
    },
    Getsupplier() {
      var cm = [{ Name: "Select Commodity", Id: 0 }, ...this.SUPPLIER];
      return cm;
    }
  }
};
</script>